import React from 'react'

import PropTypes from 'prop-types'

import './testimonials-card.css'

const TestimonialsCard = (props) => {
  return (
    <div className="testimonials-card-container1">
      <div className="testimonials-card-container2">
        <img
          alt={props.imageAlt1}
          src={props.imageSrc1}
          className="testimonials-card-image"
        />
        <div className="testimonials-card-container3">
          <span className="testimonials-card-text Lead1">{props.text}</span>
        </div>
      </div>
    </div>
  )
}

TestimonialsCard.defaultProps = {
  imageAlt1: 'image',
  text: 'I used Landify and created a landing page for my startup within a week. The Landify UI Kit is simple and highly intuitive, so anyone can use it.',
  imageSrc1: '/quote-mark.svg',
}

TestimonialsCard.propTypes = {
  imageAlt1: PropTypes.string,
  text: PropTypes.string,
  imageSrc1: PropTypes.string,
}

export default TestimonialsCard
